export default function SectionLabel({ children, className = "" }) {
  return (
    <div className={`label-eyebrow ${className}`}>
      <span className="inline-block w-6 h-px bg-[#FF4A00] align-middle mr-3" />
      {children}
    </div>
  );
}
